/*eslint comma-dangle: ["error", "never"]*/
export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
      jQuery(window).on('scroll', function() {
          var y_scroll_pos = window.pageYOffset;
          var scroll_pos_test = 150;             // set to whatever you want it to be

          if(y_scroll_pos > scroll_pos_test) {
              jQuery('.search-box').addClass('fixedToTop');
          }else{
              jQuery('.search-box').removeClass('fixedToTop');
          }
      });

      jQuery('.search-box .initialView').click(function(){
        jQuery(this).addClass('hidden');
        jQuery(this).parent().find('input').focus();
      });

      jQuery('.search-box input').blur(function(){
        jQuery(this).parent().find('.initialView').removeClass('hidden');
      });

      jQuery('.footer-slick').slick({
          dots: false,
          infinite: true,
          speed: 300,
          autoplay: true,
          autoplaySpeed: 2000,
          slidesToShow: 5,
          slidesToScroll: 2,
          responsive: [
              {
                  breakpoint: 1024,
                  settings: {
                      slidesToShow: 3,
                      slidesToScroll: 3
                  }
              },
              {
                  breakpoint: 600,
                  settings: {
                      slidesToShow: 3,
                      slidesToScroll: 3
                  }
              },
              {
                  breakpoint: 480,
                  settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2
                  }
              }
              // You can unslick at a given breakpoint now by adding:
              // settings: "unslick"
              // instead of a settings object
          ]
      });
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js